module.exports = __webpack_public_path__ + "media/images/instagramColorIcon-3b5080c6.svg";